import type { RadarFilter } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarFilterTypes';

export const mapMixedAirport = (stats: RadarFilter | undefined) => {
  if (!stats) return undefined;
  return {
    itineraries: { has_city_open_jaw: stats.hasCityOpenJaw },
  };
};
